"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockAssetsResponseToJSON = exports.StockAssetsResponseFromJSONTyped = exports.StockAssetsResponseFromJSON = exports.instanceOfStockAssetsResponse = void 0;
var runtime_1 = require("../runtime");
var Paging_1 = require("./Paging");
var StockBackgroundMusic_1 = require("./StockBackgroundMusic");
/**
 * Check if a given object implements the StockAssetsResponse interface.
 */
function instanceOfStockAssetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStockAssetsResponse = instanceOfStockAssetsResponse;
function StockAssetsResponseFromJSON(json) {
    return StockAssetsResponseFromJSONTyped(json, false);
}
exports.StockAssetsResponseFromJSON = StockAssetsResponseFromJSON;
function StockAssetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'assets': !(0, runtime_1.exists)(json, 'assets') ? undefined : (json['assets'].map(StockBackgroundMusic_1.StockBackgroundMusicFromJSON)),
    };
}
exports.StockAssetsResponseFromJSONTyped = StockAssetsResponseFromJSONTyped;
function StockAssetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'assets': value.assets === undefined ? undefined : (value.assets.map(StockBackgroundMusic_1.StockBackgroundMusicToJSON)),
    };
}
exports.StockAssetsResponseToJSON = StockAssetsResponseToJSON;
